import React from 'react';
import { ScrollView } from 'react-native'; // Import ScrollView
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import styled from 'styled-components/native';
import ActivityRow from './ActivityRow.js';

function ActivityList(props) {  

  ////console.log('activityObj' , props.route.params.activityObj);
  return (
    <ScrollView> 
      <ActivityListParent>
        {props.route.params.activityObj.map((item, index) => (
          <ActivityRow 
            key={index}
            activities={item.activity_list}
            rows={props.route.params.activityObj.length}
            workout={props.route.params.current_workout}
            category_name={item.category_name}
            category_text={item.category_text}
            navigation={props.navigation}
            isWorkout={props.route.params.isWorkout}
          />
        ))}
      </ActivityListParent>
    </ScrollView>
  );
}

export const ActivityListParent = styled.View`
  width: 100%;
  height: 100%;
  margin-top: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-grow:1;
`;

export default ActivityList;